"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const transactionSigningAction_1 = require("@/features/transaction-signing/actions/transactionSigningAction");
const transactionSigningSelector_1 = require("../selectors/transactionSigningSelector");
// import { SYSTEM_MESSAGES_COMMON } from "@/common/utils/constants";
const types_1 = require("../types");
const transactionSigningApi_1 = require("../apis/transactionSigningApi");
const constants_1 = require("../constants");
const _tacLog1 = 'tac validate: responseWrapper';
const _tacLog2 = 'tac validate: responseWrapper.data';
const _tacLog3 = 'tac validate: responseWrapper.errorCode';
const _rwLog1 = 'responseWrapper.data';
const _errCode20058 = 'CAUTH-20058';
const _errDscp20058 = 'Verify tac failure wrong OTP format';
const _errCode20012 = 'CAUTH-20012';
const mfaOtpError = 'handleToggleSWKResendNotification, send mfa-otp error, ignore !!';
function* handleSubmitTransactionSigning() {
    console.log('handleSubmiTransactionSigning');
    yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningOTPLayout)());
}
function* handleToggleMobilePhone() {
    console.log('handleToggleMobilePhone');
    window.alert('we are under construction');
    yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningOTPLayout)());
}
function* handleToggleResendNotification() {
    console.log('saga-handleToggleResendNotification');
    const { authorizationId, authorizationTypeCode, accessToken } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const params = {
        authorizationId,
        authorizationTypeCode
    };
    const headers = {
        'x-acc-op': accessToken
    };
    const respsonseWrapper = yield (0, effects_1.call)(transactionSigningApi_1.apiMfaSendOtpWrapper, params, headers);
    if (respsonseWrapper.isError || respsonseWrapper.data.status !== 'SUCCESS') {
        console.error('handleToggleResendNotification, send mfa-otp error, ignore !!');
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showResendOTPSuccessLayout)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(respsonseWrapper.data.data.authorizationId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationReference)(respsonseWrapper.data.data.authorizationReference));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationTypeCode)(respsonseWrapper.data.data.authorizationTypeCode));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setTransactionId)(respsonseWrapper.data.data.transactionId));
    }
}
function* handleToggleResendEmailNotification() {
    console.log('saga-handleToggleResendEmailNotification');
    const { authorizationId, authorizationTypeCode, accessToken } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const params = {
        authorizationId,
        authorizationTypeCode
    };
    const headers = {
        'x-acc-op': accessToken
    };
    const respsonseWrapper = yield (0, effects_1.call)(transactionSigningApi_1.apiMfaSendOtpWrapper, params, headers);
    if (respsonseWrapper.isError || respsonseWrapper.data.status !== 'SUCCESS') {
        console.error('handleToggleResendEmailNotification, send mfa-otp error, ignore !!');
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showResendEmailOTPSuccessLayout)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(respsonseWrapper.data.data.authorizationId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationReference)(respsonseWrapper.data.data.authorizationReference));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationTypeCode)(respsonseWrapper.data.data.authorizationTypeCode));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setTransactionId)(respsonseWrapper.data.data.transactionId));
    }
}
function* handleToggleSWKResendNotification() {
    console.log('saga-handleToggleSWKResendNotification');
    yield (0, effects_1.put)((0, transactionSigningAction_1.endAuthorizationStatus)());
    yield (0, effects_1.put)((0, transactionSigningAction_1.showOneTokenWithFooterLayout)());
    const { transactionType, authorizationTypeCode, providerCode, transactionId, authorizationId } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const headers = {};
    const params = {
        transactionType,
        providerCode,
        transactionId,
        authorizationTypeCode,
        authorizationId
    };
    const responseWrapperSWKResend = yield (0, effects_1.call)(transactionSigningApi_1.apiMfaSendSoftTokenWrapper, params, headers);
    if (responseWrapperSWKResend.isError || responseWrapperSWKResend.data.status !== 'SUCCESS') {
        console.error(mfaOtpError);
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setExpirySeconds)(responseWrapperSWKResend.data.softSign.expirySecs));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setRefCode)(responseWrapperSWKResend.data.softSign.refCode));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(responseWrapperSWKResend.data.softSign.traceId));
    }
    yield (0, effects_1.put)((0, transactionSigningAction_1.startAuthorizationStatus)());
}
function* handleToggleChangePasswordResendNotification() {
    console.log('saga-handleToggleSWKResendNotification');
    yield (0, effects_1.put)((0, transactionSigningAction_1.endAuthorizationStatus)());
    yield (0, effects_1.put)((0, transactionSigningAction_1.showChangePasswordOneTokenWithFooterLayout)());
    const { transactionType, authorizationTypeCode, authorizationId, providerCode, transactionId } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const params = {
        transactionType,
        providerCode,
        transactionId,
        authorizationTypeCode,
        authorizationId
    };
    const headers = {};
    const responseWrapperChangePasswordResend = yield (0, effects_1.call)(transactionSigningApi_1.apiMfaSendSoftTokenWrapper, params, headers);
    if (responseWrapperChangePasswordResend.isError || responseWrapperChangePasswordResend.data.status !== 'SUCCESS') {
        console.error(mfaOtpError);
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setExpirySeconds)(responseWrapperChangePasswordResend.data.softSign.expirySecs));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setRefCode)(responseWrapperChangePasswordResend.data.softSign.refCode));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(responseWrapperChangePasswordResend.data.softSign.traceId));
    }
    yield (0, effects_1.put)((0, transactionSigningAction_1.startAuthorizationStatus)());
}
function* handleToggleCloseInvalid({ payload: _cancel }) {
    if (_cancel) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.cancelTransactionSigningWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setOtpCode)(''));
        yield (0, effects_1.put)((0, transactionSigningAction_1.showTransactionSigningOTPLayout2)());
    }
}
function* handleToggleCloseInvalidOfflineOTP({ payload: _cancel }) {
    if (_cancel) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.cancelTransactionSigningWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setOtpCode)(' '));
        yield (0, effects_1.put)((0, transactionSigningAction_1.showTransactionSigningOfflineOTPLayout)());
    }
}
function* handleToggleCloseGeneralError({ payload: _cancel }) {
    if (_cancel) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.cancelTransactionSigningWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.API_ERROR));
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setOtpCode)(''));
    }
}
function* handleToggleCloseExceedMaximumRetry({ payload: _cancel }) {
    if (_cancel) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.cancelTransactionSigningWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.EXCEED_MAXIMUM_RETRY));
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setOtpCode)(''));
    }
}
function* handleToggleCloseUserNoActiveHardToken({ payload: _cancel }) {
    if (_cancel) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.cancelTransactionSigningWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_NO_ACTIVE_HARD_TOKEN));
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setOtpCode)(''));
    }
}
function* handleToggleCloseUserNoActiveSoftToken({ payload: _cancel }) {
    if (_cancel) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.cancelTransactionSigningWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_NO_ACTIVE_SOFT_TOKEN));
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setOtpCode)(''));
    }
}
function* handleToggleSubmitOtp() {
    console.log('saga-handleToggleSubmitOtp');
    yield (0, effects_1.put)((0, transactionSigningAction_1.endAuthorizationStatus)());
    const { otpCode, transactionId, transactionSigningCallbackSuccess, authorizationId, authorizationReference, accessToken } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const params = {
        transactionId,
        authorizationId,
        otp: otpCode,
        authorizationReference
    };
    const headers = {
        'x-acc-op': accessToken
    };
    const responseWrapper = yield (0, effects_1.call)(transactionSigningApi_1.apiTACValidateWrapper, params, headers);
    console.log(_tacLog1, responseWrapper);
    console.log(_tacLog2, responseWrapper.data);
    console.log(_tacLog3, responseWrapper.errorCode);
    if (responseWrapper.isError) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showInvalidOTPLayout)());
        yield (0, effects_1.delay)(200);
        // yield put(dismissTransactionSigningOTPLayout());
    }
    else if (responseWrapper.data.status === 'SUCCESS') {
        console.log('responseWrapper', responseWrapper);
        console.log(_rwLog1, responseWrapper.data);
        // If status is success but empty data is returned, then transaction signing is not multi-step and taken to be finished
        if (!responseWrapper.data.data || !responseWrapper.data.data.authorizationTypeCode || Object.keys(responseWrapper.data.data).length === 0) {
            console.log('Status: SUCCESS. No authzTypeCode or other data returned. Transaction signing finished, not multi-step');
            yield (0, effects_1.put)((0, transactionSigningAction_1.endTransactionSigningWorkFlowSuccessfully)());
            transactionSigningCallbackSuccess();
        }
        else {
            yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(responseWrapper.data.data.authorizationId));
            yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationReference)(responseWrapper.data.data.authorizationReference));
            yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationTypeCode)(responseWrapper.data.data.authorizationTypeCode));
            yield (0, effects_1.put)((0, transactionSigningAction_1.setTransactionId)(responseWrapper.data.data.transactionId));
            yield (0, effects_1.put)((0, transactionSigningAction_1.setMaskedMobileNo)(responseWrapper.data.data.maskedMobileNo));
            yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningOTPLayout)());
            if (responseWrapper.data.data.authorizationTypeCode.toString().toLowerCase() === 'email_otp') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.showTransactionSigningEmailVerification)());
            }
            else if (responseWrapper.data.data.authorizationTypeCode.toString().toLowerCase() === 'swk') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.showTransactionSigningOneTokenLayout)());
                yield (0, effects_1.delay)(2000);
                yield (0, effects_1.put)((0, transactionSigningAction_1.startAuthorizationStatus)());
                yield (0, effects_1.delay)(2000);
            }
            else if (responseWrapper.data.data.authorizationTypeCode.toString().toLowerCase() === 'hwk') {
                return;
            }
            else {
                yield (0, effects_1.put)((0, transactionSigningAction_1.endTransactionSigningWorkFlowSuccessfully)());
                transactionSigningCallbackSuccess();
            }
        }
    }
    else if (responseWrapper.data.status === 'FAILED' &&
        responseWrapper.data.errorCode === _errCode20058 &&
        responseWrapper.data.description === _errDscp20058) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showInvalidOTPLayout)());
    }
    else if (responseWrapper.data.status === 'FAILED' && responseWrapper.data.errorCode === _errCode20012) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showExceedMaximumRetry)());
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showGeneralError)());
        yield (0, effects_1.delay)(200);
    }
}
function* handleToggleSubmitOfflineOtp() {
    console.log('saga-handleToggleSubmitOfflineOtp');
    yield (0, effects_1.put)((0, transactionSigningAction_1.endAuthorizationStatus)());
    //const { otpCode, transactionId, authorizationId, accessToken, authorizationTypeCode, transactionSigningCallbackSuccess } = yield select(
    const { otpCode, transactionId, authorizationId, authorizationTypeCode, transactionSigningCallbackSuccess } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const params = {
        transactionId,
        otp: otpCode,
        authorizationId,
        authorizationTypeCode
    };
    const headers = {};
    const responseWrapper = yield (0, effects_1.call)(transactionSigningApi_1.apiValidateOTPWrapper, params, headers);
    if (responseWrapper.isError) {
        // yield put(showInvalidOfflineOTPLayout())
        // yield delay(200)
        // yield put(dismissTransactionSigningOTPLayout());
    }
    else if (responseWrapper.data.status === 'SUCCESS') {
        console.log('responseWrapper', responseWrapper);
        console.log(_rwLog1, responseWrapper.data);
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(responseWrapper.data.softSign.traceId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningOfflineOTPLayout)());
        // yield put(showTransactionSigningApproved())
        yield (0, effects_1.delay)(2000);
        // yield put(dismissTransactionSigningApproved())
        yield (0, effects_1.put)((0, transactionSigningAction_1.endTransactionSigningWorkFlowSuccessfully)());
        transactionSigningCallbackSuccess();
    }
    else if (responseWrapper.data.status === 'EXCEED_2FA_MAX_ATTEMPT') {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showExceedMaximumRetry)());
    }
    else if (responseWrapper.data.status !== 'FAILED') {
        // yield put(setOtpCode(''))
        yield (0, effects_1.put)((0, transactionSigningAction_1.setErrorMsg)(constants_1.OFFLINE_OTP.INVALID_RESPONSE_CODE));
    }
}
function* handleToggleSubmitOtpNoAuthorizationStatus() {
    console.log('saga-handleToggleSubmitOtpNoAuthorizationStatus');
    const { otpCode, transactionId, authorizationId, accessToken, authorizationReference } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const params = {
        transactionId,
        otp: otpCode,
        authorizationId,
        authorizationReference
    };
    const headers = {
        'x-acc-op': accessToken
    };
    const responseWrapper = yield (0, effects_1.call)(transactionSigningApi_1.apiTACValidateWrapper, params, headers);
    console.log(_tacLog1, responseWrapper);
    console.log(_tacLog2, responseWrapper.data);
    console.log(_tacLog3, responseWrapper.errorCode);
    if (responseWrapper.isError) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showInvalidOTPLayout)());
        yield (0, effects_1.delay)(200);
        // yield put(dismissTransactionSigningOTPLayout());
    }
    else if (responseWrapper.data.status === 'SUCCESS') {
        console.log('responseWrapper', responseWrapper);
        console.log(_rwLog1, responseWrapper.data);
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(responseWrapper.data.data.authorizationId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationReference)(responseWrapper.data.data.authorizationReference));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationTypeCode)(responseWrapper.data.data.authorizationTypeCode));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setTransactionId)(responseWrapper.data.data.transactionId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setMaskedMobileNo)(responseWrapper.data.data.maskedMobileNo));
        yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningOTPLayout)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.showTransactionSigningEmailVerification)());
    }
    else if (responseWrapper.data.status === 'FAILED' &&
        responseWrapper.data.errorCode === _errCode20058 &&
        responseWrapper.data.description === _errDscp20058) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showInvalidOTPLayout)());
    }
    else if (responseWrapper.data.status === 'FAILED' && responseWrapper.data.errorCode === _errCode20012) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showExceedMaximumRetry)());
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showGeneralError)());
        yield (0, effects_1.delay)(200);
    }
}
function* handleToggleSubmitEmailOtp() {
    console.log('saga-handleToggleSubmitEmailOtp');
    const { otpCode, authorizationId, authorizationReference, transactionId, accessToken, transactionSigningCallbackSuccess } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const params = {
        transactionId,
        authorizationId,
        authorizationReference,
        otp: otpCode
    };
    const headers = {
        'x-acc-op': accessToken
    };
    const responseWrapper = yield (0, effects_1.call)(transactionSigningApi_1.apiTACValidateWrapper, params, headers);
    console.log(_tacLog1, responseWrapper);
    console.log(_tacLog2, responseWrapper.data);
    console.log(_tacLog3, responseWrapper.errorCode);
    if (responseWrapper.isError) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showInvalidOTPLayout)());
        yield (0, effects_1.delay)(200);
        // yield put(dismissTransactionSigningOTPLayout());
    }
    else if (responseWrapper.data.status === 'SUCCESS') {
        console.log('responseWrapper', responseWrapper);
        console.log(_rwLog1, responseWrapper.data);
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(responseWrapper.data.data.authorizationId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationReference)(responseWrapper.data.data.authorizationReference));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationTypeCode)(responseWrapper.data.data.authorizationTypeCode));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setTransactionId)(responseWrapper.data.data.transactionId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setMaskedMobileNo)(responseWrapper.data.data.maskedMobileNo));
        yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningEmailVerification)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.showTransactionSigningApproved)());
        yield (0, effects_1.delay)(2000);
        yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningApproved)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.endTransactionSigningWorkFlowSuccessfully)());
        transactionSigningCallbackSuccess();
    }
    else if (responseWrapper.data.status === 'FAILED' &&
        responseWrapper.data.errorCode === _errCode20058 &&
        responseWrapper.data.description === _errDscp20058) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showInvalidOTPLayout)());
    }
    else if (responseWrapper.data.status === 'FAILED' && responseWrapper.data.errorCode === _errCode20012) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showExceedMaximumRetry)());
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showGeneralError)());
        yield (0, effects_1.delay)(200);
    }
}
function* handleAuthorizationStatus() {
    let triedCounts = 0;
    const { authorizationId, transactionId, refCode, authorizationTypeCode, expirySecs } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const MAX_TRY_COUNTS = expirySecs / 3;
    while (triedCounts < MAX_TRY_COUNTS) {
        triedCounts++;
        const params = {
            authorizationId: authorizationId,
            transactionId: transactionId,
            refCode: refCode,
            authorizationTypeCode: authorizationTypeCode
        };
        const headers = {};
        const responseWrapper = yield (0, effects_1.call)(transactionSigningApi_1.apiTacAuthorizationStatusRetrieveWrapper, params, headers);
        if (responseWrapper.isError) {
            // continue
        }
        else {
            if (responseWrapper.data.status === 'SUCCESS' && responseWrapper.data.softSign.transactionStatus === 1) {
                console.log('verify success');
                if (constants_1.isR4) {
                    window.parent.postMessage({ type: constants_1.R4_MESSAGE_TYPE.TAC_SUCCESS }, constants_1.parentOrigin);
                }
                yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.SUCCESS));
                return;
            }
            if (responseWrapper.data.status === 'SUCCESS' && responseWrapper.data.softSign.transactionStatus === 2) {
                if (constants_1.isR4) {
                    window.parent.postMessage({ type: constants_1.R4_MESSAGE_TYPE.TAC_CANCEL }, constants_1.parentOrigin);
                }
                yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
                return;
            }
            if (responseWrapper.data.status === 'SUCCESS' &&
                responseWrapper.data.softSign.transactionStatus !== 0 &&
                responseWrapper.data.softSign.transactionStatus !== 3) {
                // FAILED need to change to OTP screen
                console.log('verify failed');
                yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.FAILED));
                return;
            }
            if (responseWrapper.data.status === 'EXCEED_2FA_MAX_ATTEMPT') {
                // FAILED need to change to OTP screen
                yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
                yield (0, effects_1.put)((0, transactionSigningAction_1.showExceedMaximumRetry)());
                return;
            }
            if (responseWrapper.data.status === 'USER_NO_ACTIVE_HARD_TOKEN') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
                yield (0, effects_1.put)((0, transactionSigningAction_1.showUserNoActiveHardToken)());
                return;
            }
            if (responseWrapper.data.status === 'USER_NO_ACTIVE_SOFT_TOKEN') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
                yield (0, effects_1.put)((0, transactionSigningAction_1.showUserNoActiveSoftToken)());
                return;
            }
        }
        if (triedCounts > MAX_TRY_COUNTS) {
            console.error('exceed to max try counts !!');
            yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.MAX_TRY_COUNTS));
            return;
        }
        yield (0, effects_1.delay)(3000);
    }
}
function* handleToggleGenerateOtp() {
    const { 
    //authorizationId,
    //accessToken,
    authorizationTypeCode } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    if (authorizationTypeCode === 'hard') {
        return;
    }
    yield (0, effects_1.put)((0, transactionSigningAction_1.endAuthorizationStatus)());
    yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningOneTokenLayout)());
    yield (0, effects_1.put)((0, transactionSigningAction_1.showTransactionSigningOfflineOTPLayout)());
    // const params = {
    // 	authorizationId,
    // 	authorizationTypeCode: 'SWK_MANUAL'
    // } as IMfa_SendOtpRequest
    //
    // const headers = {
    // 	'x-acc-op': accessToken
    // }
    // const responseWrapper: IMfa_SendOtpResponseWrapper = yield call(apiMfaSendOtpWrapper, params, headers)
    // if (responseWrapper.isError || responseWrapper.data.status !== 'SUCCESS') {
    // 	console.error('mfa-send-otp failed')
    // 	yield put(cancelTransactionSigningWorkFlow(WORKFLOW_CANCEL_REASON.API_ERROR))
    // } else {
    // 	yield put(setAuthorizationId(responseWrapper.data.data.authorizationId))
    // 	yield put(setAuthorizationReference(responseWrapper.data.data.authorizationReference))
    // 	yield put(setAuthorizationTypeCode(responseWrapper.data.data.authorizationTypeCode))
    // 	yield put(setTransactionId(responseWrapper.data.data.transactionId))
    // 	yield put(setChallengeCode(responseWrapper.data.data.challengeCode))
    // }
}
function* handleToggleGenerateChangePasswordOtp() {
    console.log('handleToggleGenerateChangePasswordOtp()');
    const { authorizationTypeCode } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    if (authorizationTypeCode === 'hard') {
        return;
    }
    yield (0, effects_1.put)((0, transactionSigningAction_1.endAuthorizationStatus)());
    yield (0, effects_1.put)((0, transactionSigningAction_1.dismissChangePasswordOneTokenLayout)());
    yield (0, effects_1.put)((0, transactionSigningAction_1.showChangePasswordOfflineOTPLayout)());
}
function* handleToggleCloseOneToken() {
    yield (0, effects_1.put)((0, transactionSigningAction_1.cancelTransactionSigningWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
}
function* handleToggleCloseOtp() {
    yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOtp)());
}
function* handleToggleCloseEmailOtp() {
    yield (0, effects_1.put)((0, transactionSigningAction_1.cancelTransactionSigningWorkFlow)(types_1.WORKFLOW_CANCEL_REASON.USER_CANCEL));
}
function* handleToggleCallTrxnSigningSuccessCallback() {
    const { transactionSigningCallbackSuccess } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    transactionSigningCallbackSuccess();
}
function* handleToggleCallTrxnSigningFailureCallback() {
    const { transactionSigningCallbackFailure } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    transactionSigningCallbackFailure();
}
function* handleStartAuthorizationStatus() {
    const authorizationStatusTask = yield (0, effects_1.fork)(handleAuthorizationStatus);
    const interuptionActions = yield (0, effects_1.take)([transactionSigningAction_1.TransactionSigningType.END_AUTHORIZATION_STATUS, transactionSigningAction_1.TransactionSigningType.SET_AUTHORIZATION_STATUS_RESULT]);
    console.log('handleStartAuthorizationStatus, interuptionActions:', interuptionActions);
    yield (0, effects_1.cancel)(authorizationStatusTask);
}
function* handleSetAuthorizationStatusResult({ payload: authorizationStatusResult }) {
    console.log('handleSetAuthorizationStatusResult', authorizationStatusResult);
    const { transactionSigningCallbackSuccess, authorizationTypeCode } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    switch (authorizationStatusResult) {
        case types_1.AuthorizationStatusResult.SUCCESS:
            if ((authorizationTypeCode === null || authorizationTypeCode === void 0 ? void 0 : authorizationTypeCode.toUpperCase()) !== 'HARD') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.dismissTransactionSigningOneTokenLayout)());
                // yield put(showTransactionSigningApproved());
                // yield delay(2000);
                // yield put(dismissTransactionSigningApproved());
                yield (0, effects_1.delay)(2000);
            }
            yield (0, effects_1.put)((0, transactionSigningAction_1.endTransactionSigningWorkFlowSuccessfully)());
            transactionSigningCallbackSuccess();
            break;
        case types_1.AuthorizationStatusResult.FAILED:
            if (authorizationTypeCode === 'hard') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.setErrorMsg)(constants_1.SYSTEM_MESSAGE_HARD_TOKEN.INVALID_RESPONSE_CODE));
            }
            yield (0, effects_1.put)((0, transactionSigningAction_1.toggleGenerateOtp)());
            break;
        case types_1.AuthorizationStatusResult.MAX_TRY_COUNTS:
            yield (0, effects_1.put)((0, transactionSigningAction_1.toggleGenerateOtp)());
            break;
        default:
            break;
    }
}
function* handleStartTransactionSigning() {
    // handleToggleSWKResendNotification()
    const { authorizationId, authRequestDetail, authorizationTypeCode } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const { transactionId, transactionType, providerCode } = authRequestDetail.context;
    const headers = {};
    const params = {
        transactionType,
        providerCode,
        transactionId,
        authorizationTypeCode,
        authorizationId
    };
    const responseWrapperTransactionSigning = yield (0, effects_1.call)(transactionSigningApi_1.apiMfaSendSoftTokenWrapper, params, headers);
    if (responseWrapperTransactionSigning.data.status === 'EXCEED_2FA_MAX_ATTEMPT') {
        yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.showExceedMaximumRetry)());
    }
    else if (responseWrapperTransactionSigning.data.status === 'USER_NO_ACTIVE_HARD_TOKEN') {
        yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.showUserNoActiveHardToken)());
    }
    else if (responseWrapperTransactionSigning.data.status === 'USER_NO_ACTIVE_SOFT_TOKEN') {
        yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.showUserNoActiveSoftToken)());
    }
    else if (responseWrapperTransactionSigning.isError || responseWrapperTransactionSigning.data.status !== 'SUCCESS') {
        console.error(mfaOtpError);
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setExpirySeconds)(responseWrapperTransactionSigning.data.softSign.expirySecs));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setRefCode)(responseWrapperTransactionSigning.data.softSign.refCode));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(responseWrapperTransactionSigning.data.softSign.traceId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.showTransactionSigningOneTokenLayout)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.startAuthorizationStatus)());
    }
}
function* handleStartChangePassword() {
    // handleToggleSWKResendNotification()
    const { authRequestDetail, authorizationTypeCode, authorizationId } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const { transactionType, providerCode, transactionId } = authRequestDetail.context;
    const params = {
        transactionType,
        providerCode,
        transactionId,
        authorizationTypeCode,
        authorizationId
    };
    const headers = {};
    const responseWrapper = yield (0, effects_1.call)(transactionSigningApi_1.apiMfaSendSoftTokenWrapper, params, headers);
    if (responseWrapper.data.status === 'EXCEED_2FA_MAX_ATTEMPT') {
        yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.showExceedMaximumRetry)());
    }
    else if (responseWrapper.data.status === 'USER_NO_ACTIVE_HARD_TOKEN') {
        yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseOneToken)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.showUserNoActiveHardToken)());
    }
    else if (responseWrapper.isError || responseWrapper.data.status !== 'SUCCESS') {
        console.error(mfaOtpError);
    }
    else {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setExpirySeconds)(responseWrapper.data.softSign.expirySecs));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setRefCode)(responseWrapper.data.softSign.refCode));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationId)(responseWrapper.data.softSign.traceId));
        yield (0, effects_1.put)((0, transactionSigningAction_1.showChangePasswordOneTokenLayout)());
        yield (0, effects_1.put)((0, transactionSigningAction_1.startAuthorizationStatus)());
    }
}
function* startTransactionSigningSaga() {
    yield (0, effects_1.takeLatest)(transactionSigningAction_1.TransactionSigningType.HANDLE_SUBMIT_TRANSACTION_SIGNING, handleSubmitTransactionSigning);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_RESEND_NOTIFICATION, handleToggleResendNotification);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_RESEND_EMAIL_NOTIFICATION, handleToggleResendEmailNotification);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_SWK_RESEND_NOTIFICATION, handleToggleSWKResendNotification);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CHANGEPASSWORD_RESEND_NOTIFICATION, handleToggleChangePasswordResendNotification);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_GENERATE_OTP, handleToggleGenerateOtp);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CHANGEPASSWORD_GENERATE_OTP, handleToggleGenerateChangePasswordOtp);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_OTP, handleToggleCloseOtp);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_SUBMIT_OTP, handleToggleSubmitOtp);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_SUBMIT_OFFLINE_OTP, handleToggleSubmitOfflineOtp);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_MOBILE_PHONE, handleToggleMobilePhone);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_INVALID_OTP, handleToggleCloseInvalid);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_INVALID_OFFLINE_OTP, handleToggleCloseInvalidOfflineOTP);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_GENERAL_ERROR, handleToggleCloseGeneralError);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_EXCEED_MAXIMUM_RETRY, handleToggleCloseExceedMaximumRetry);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_USER_NO_ACTIVE_HARD_TOKEN, handleToggleCloseUserNoActiveHardToken);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_USER_NO_ACTIVE_SOFT_TOKEN, handleToggleCloseUserNoActiveSoftToken);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_ONE_TOKEN, handleToggleCloseOneToken);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_CLOSE_EMAIL_OTP, handleToggleCloseEmailOtp);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_SUBMIT_EMAIL_OTP, handleToggleSubmitEmailOtp);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_SUBMIT_OTP_NO_AUTHORIZATION_STATUS, handleToggleSubmitOtpNoAuthorizationStatus);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.CALL_TRANSACTION_SIGNING_SUCCESS_CALLBACK, handleToggleCallTrxnSigningSuccessCallback);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.CALL_TRANSACTION_SIGNING_FAILURE_CALLBACK, handleToggleCallTrxnSigningFailureCallback);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.SET_AUTHORIZATION_STATUS_RESULT, handleSetAuthorizationStatusResult);
    yield (0, effects_1.takeLatest)(transactionSigningAction_1.TransactionSigningType.START_AUTHORIZATION_STATUS, handleStartAuthorizationStatus);
    yield (0, effects_1.takeEvery)(transactionSigningAction_1.TransactionSigningType.TOGGLE_SUBMIT_HARDWARE_TOKEN, handleToggleSubmitHradWareToken);
    yield (0, effects_1.takeLatest)(transactionSigningAction_1.TransactionSigningType.START_TRANSACTION_SIGNING, handleStartTransactionSigning);
    yield (0, effects_1.takeLatest)(transactionSigningAction_1.TransactionSigningType.START_CHANGE_PASSWORD, handleStartChangePassword);
}
function* handleToggleSubmitHradWareToken() {
    var _a, _b;
    function* handleResult(result) {
        if (result.isError) {
            if (result.status === 'FAILED') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.setErrorMsg)(result.systemMessages));
                yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.FAILED));
            }
            else if (result.status === 'EXCEED_2FA_MAX_ATTEMPT') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.setErrorMsg)(result.systemMessages));
                yield (0, effects_1.put)((0, transactionSigningAction_1.setLogoutDetail)(result.data));
                yield (0, effects_1.put)((0, transactionSigningAction_1.setMaxAttemptExceeded)(true));
                yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseHardTokenOtp)());
                yield (0, effects_1.put)((0, transactionSigningAction_1.showExceedMaximumRetry)());
            }
            else if (result.status === 'USER_NO_ACTIVE_HARD_TOKEN') {
                yield (0, effects_1.put)((0, transactionSigningAction_1.toggleCloseHardTokenOtp)());
                yield (0, effects_1.put)((0, transactionSigningAction_1.showUserNoActiveHardToken)());
            }
        }
        else if (result.isError === false && result.data.result === 'SUCCESS') {
            console.log('hard token verify success');
            yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.SUCCESS));
            if (constants_1.isR4) {
                window.parent.postMessage({ type: constants_1.R4_MESSAGE_TYPE.TAC_SUCCESS }, constants_1.parentOrigin);
            }
        }
        else {
            // FAILED need to change to OTP screen
            console.log('verify failed');
            yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.FAILED));
        }
    }
    console.log('handleToggleSubmitHradWareToken start :');
    const { authRequestDetail, hardTokenOTP, authorizationId, transactionId } = yield (0, effects_1.select)(transactionSigningSelector_1.transactionSigningSelector);
    const { orgId, loginId: userId } = authRequestDetail.context;
    const otpType = (_a = authRequestDetail === null || authRequestDetail === void 0 ? void 0 : authRequestDetail.context) === null || _a === void 0 ? void 0 : _a.otpType;
    const hardTokenchallengeCode = (_b = authRequestDetail === null || authRequestDetail === void 0 ? void 0 : authRequestDetail.context) === null || _b === void 0 ? void 0 : _b.challengeCode;
    const isFinancial = otpType !== 'CR';
    const attr = {
        orgId,
        userId,
        authType: 'pwd',
        isBindHardToken: 'Y',
        tokenGenerateNo: hardTokenOTP,
        authorizationId,
        transactionId,
        hardTokenOTP
    };
    console.log(attr);
    const headers = {};
    let payloadData;
    if (isFinancial) {
        payloadData = {
            authorizationId,
            authorizationTypeCode: 'hard',
            transactionType: authRequestDetail.context.transactionType,
            transactionId,
            accountNo: authRequestDetail.context.accountNo,
            amount: authRequestDetail.context.amount,
            token: hardTokenOTP
        };
    }
    else {
        payloadData = {
            otp: hardTokenOTP,
            challenge: hardTokenchallengeCode,
            authorizationId
        };
    }
    try {
        yield (0, effects_1.put)((0, transactionSigningAction_1.showLoadingSpinner)());
        const response = yield (0, effects_1.call)(transactionSigningApi_1.apiPaymentHardTokenSubmit, payloadData, headers, isFinancial);
        yield* handleResult(response);
    }
    catch (e) {
        yield (0, effects_1.put)((0, transactionSigningAction_1.setErrorMsg)(constants_1.SYSTEM_MESSAGE_HARD_TOKEN.HOST_ERROR));
        yield (0, effects_1.put)((0, transactionSigningAction_1.setAuthorizationStatusResult)(types_1.AuthorizationStatusResult.FAILED));
    }
    finally {
        yield (0, effects_1.put)((0, transactionSigningAction_1.dismissLoadingSpinner)());
    }
}
function* startTransactionSigningWorkflow() {
    console.log('saga-startTransactionSigningWorkflow');
    // yield takeEvery(TransactionSigningType.START_TRANSACTION_SIGNING_WORKFLOW, transactionSigningWorkflow);
    while (true) {
        // const workflow = yield fork(startTransactionSigningSaga);
        const workflow = yield (0, effects_1.takeLatest)(transactionSigningAction_1.TransactionSigningType.START_TRANSACTION_SIGNING_WORKFLOW, startTransactionSigningSaga);
        yield (0, effects_1.take)(transactionSigningAction_1.TransactionSigningType.END_TRANSACTION_SIGNING_WORKFLOW);
        yield (0, effects_1.cancel)(workflow);
    }
}
function* handleSetErrorMessage(message) {
    yield (0, effects_1.put)((0, transactionSigningAction_1.setErrorMsg)(message));
}
const transactionSigningSagas = [(0, effects_1.fork)(startTransactionSigningWorkflow)];
exports.default = transactionSigningSagas;
